// UniversalTable.jsx
import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import "./table.css";
import createColumns from "./columnsConfig";

const UniversalTable = ({ data, type, setOrg, Edit, onCellChange, goto }) => {
  const navigate = useNavigate();

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const actions = { Edit, setOrg, navigate, onCellChange, goto };
  const columnsConfig = createColumns(actions);
  const columns = columnsConfig[type] || [];

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return sortConfig.direction === "asc" ? -1 : 1;
      if (bValue == null) return sortConfig.direction === "asc" ? 1 : -1;

      if (typeof aValue === "string" || typeof bValue === "string") {
        aValue = String(aValue).toLowerCase();
        bValue = String(bValue).toLowerCase();
      }

      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [data, sortConfig]);

  const handleSort = (key) => {
    if (sortConfig.key === key) {
      setSortConfig({
        key,
        direction: sortConfig.direction === "asc" ? "desc" : "asc",
      });
    } else {
      setSortConfig({ key, direction: "asc" });
    }
  };

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                width={column.width}
                onClick={() =>
                  column.sortable !== false && handleSort(column.key)
                }
                className={`th-clickable ${sortConfig.key === column.key ? `sort-${sortConfig.direction}` : ""}`}
                style={{
                  cursor: column.sortable !== false ? "pointer" : "default",
                }}
              >
                <div className="th-content">
                  {column.title}
                  {sortConfig.key === column.key && (
                    <span className="sort-indicator">
                      {sortConfig.direction === "asc" ? " ↑" : " ↓"}
                    </span>
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedData.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="no-data">
                Нет данных
              </td>
            </tr>
          ) : (
            sortedData.map((item, index) => (
              <tr key={item.id || item.serial || index}>
                {columns.map((column) => (
                  <td key={column.key}>
                    {column.render ? column.render(item, index) : item[column.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

// ✅ PropTypes — ТОЛЬКО ПОСЛЕ объявления компонента
UniversalTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  type: PropTypes.oneOf([
    "organizations",
    "modules",
    "stations",
    "stationsInModule",
    "childModules",
    "users",
  ]).isRequired,
  setOrg: PropTypes.func,
  Edit: PropTypes.func.isRequired,
  onCellChange: PropTypes.func,
};

export default UniversalTable;
